import { AxiosResponse } from 'axios';

import apiClient from '../client';
import { PageResultDto } from 'interfaces/page';
import { ContactDto } from 'interfaces/contact';
import { ApiResponseDto } from 'interfaces/apiResponse';

interface ContactsService {
  search(queryParams?: any): Promise<PageResultDto<ContactDto>>;
  get(id: string): Promise<ContactDto>;
  create(postData: any): Promise<ContactDto>;
  edit(id: string, postData: any): Promise<AxiosResponse<ContactDto>>;
}

const endpoints = {
  search: '/contacts',
  get: (id: string) => `/contacts/${id}`,
  create: '/contacts',
  edit: (id: string) => `/contacts/${id}`,
};

export const contactsService: ContactsService = {
  search: async (queryParams?: any): Promise<PageResultDto<ContactDto>> => {
    const response: AxiosResponse<ApiResponseDto<PageResultDto<ContactDto>>> = await apiClient.get(endpoints.search, {
      params: { ...queryParams },
      paramsSerializer: { indexes: null },
    });

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  get: async (id: string): Promise<ContactDto> => {
    const response: AxiosResponse<ApiResponseDto<ContactDto>> = await apiClient.get(endpoints.get(id));

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  create: async (postData: any): Promise<ContactDto> => {
    const response: AxiosResponse<ApiResponseDto<ContactDto>> = await apiClient.post(endpoints.create, postData);

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  edit: async (id: string, postData: any): Promise<AxiosResponse<ContactDto>> => {
    return apiClient.put(endpoints.edit(id), postData);
  },
};
